import { render, staticRenderFns } from "./product-car-model-details.vue?vue&type=template&id=2bc18759"
import script from "./product-car-model-details.vue?vue&type=script&lang=js"
export * from "./product-car-model-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports